Apt.fn.make('zoom', {
	/**
	 * Initialize module
	 *
	 * @param {Object} options
	 */
	init: function(options) {
		var scope = this,
			priv = scope.$private;

		priv.$container = $(options.container);
		priv.$image = $(options.image);

		priv.options = options;

		if (! priv.$image.length) {
			return scope;
		}

		if (priv.$image[0].dataset.zoom) {
			priv.detectTouch();
			priv.setup();
		}

		if ($.screen.size() > 3) {
			$.assets.load({
				img: [
					'/assets/modules/zoom/img/zoom.svg',
					'/assets/modules/zoom/img/move.svg'
				]
			});
		}

		return scope;
	},

	/**
	 * Restore media
	 */
	restore: function() {
		this.$private.restore();
	}
}, {
	/**
	 * Setup zooming
	 */
	setup: function() {
		var scope = this,
			$container = scope.$container,
			$image = scope.$image;

		$image[0].draggable = false;

		$container.on('click', function(e) {
			if (scope.zoomed) {
				return;
			}

			scope.scaleMedia(function() {
				scope.initPan(e);
			});

			scope.zoomed = true;

			$container.off('click');

			setTimeout(function() {
				$container.on('click', function() {
					if (scope.panning) {
						return;
					}

					scope.restore();
				}, {
					namespace: 'zoom'
				});
			}, 200);
		}, {
			namespace: 'zoom'
		});
	},

	/**
	 * Restore media
	 */
	restore: function() {
		var scope = this;

		scope.restoreMedia();

		scope.$container.off(
			scope.touch ?
				'touchend' : 'mouseup'
		);

		scope.setup();
	},

	/**
	 * Detect touch events
	 */
	detectTouch: function() {
		var scope = this,
			cb = function() {
				document.removeEventListener('touchstart', cb);

				scope.touch = true;
			};

		document.addEventListener('touchstart', cb, {
			passive: true
		});
	},

	/**
	 * Initialize media panning
	 *
	 * @param {Event} [e]
	 */
	initPan: function(e) {
		var scope = this,
			container = scope.$container[0],
			$body = $($._body),
			image = scope.$image[0],
			touch = scope.touch,
			startEvent = touch ?
				'touchstart' : 'mousedown',
			moveEvent = touch ?
				'touchmove' : 'mousemove',
			endEvent = touch ?
				'touchend' : 'mouseup',
			x = 0,
			y = 0,
			xInit = 0,
			yInit = 0,
			xMove,
			yMove,
			xMax,
			yMax,
			xStart,
			yStart,
			lockX,
			lockY,
			width,
			height,
			disable;

		if (e) {
			if (image.naturalWidth > image.naturalHeight) {
				width = Math.min(image.width * 3.5, image.naturalWidth * 0.7);
				height = image.naturalHeight * (width / image.naturalWidth);
			} else {
				height = Math.min(image.height * 3.5, image.naturalHeight * 0.7);
				width = image.naturalWidth * (height / image.naturalHeight);
			}

			xMax = (width * -1) + container.clientWidth;
			yMax = (height * -1) + container.clientHeight;

			if (e.type === 'touchstart') {
				x = e.touches[0].offsetX;
				y = e.touches[0].offsetY;
			} else {
				x = e.offsetX;
				y = e.offsetY;
			}

			if (e.target === container) {
				x -= image.offsetLeft;
				y -= image.offsetTop;
			}

			x = Math.max(Math.min(image.width, x), 0);
			y = Math.max(Math.min(image.height, y), 0);

			x = Math.max(Math.min(200, (x / image.width) * (width - container.clientWidth) * -1), xMax);
			y = Math.max(Math.min(200, (y / image.height) * (height - container.clientHeight) * -1), yMax);

			lockX = width <= container.clientWidth;

			if (lockX) {
				x = 0;
			}

			lockY = height <= container.clientHeight;

			if (lockY) {
				y = 0;
			}

			xInit = x;
			yInit = y;

			image.width = width;
			image.height = height;

			image.style.transform = 'translate3d(' +
				x + 'px, ' +
				y + 'px, 0)';
		}

		scope.$container.addClass('-is-zoomed');

		scope.$container.on(startEvent, function(e) {
			if (disable) {
				clearTimeout(disable);
			}

			if (e.type === 'touchstart') {
				xStart = e.touches[0].clientX;
				yStart = e.touches[0].clientY;
			} else {
				xStart = e.clientX;
				yStart = e.clientY;
			}

			$body.on(moveEvent, function(e) {
				e.preventDefault();

				scope.panning = true;

				if (e.type === 'touchmove') {
					xMove = e.touches[0].clientX;
					yMove = e.touches[0].clientY;
				} else {
					xMove = e.clientX;
					yMove = e.clientY;
				}

				x = lockX ?
					0 : Math.max(Math.min(0, xInit + (xMove - xStart)), xMax);
				y = lockY ?
					0 : Math.max(Math.min(0, yInit + (yMove - yStart)), yMax);

				image.style.transform = 'translate3d(' +
					x + 'px, ' +
					y + 'px, 0)';
			}, {
				capture: scope.touch ? {
					passive: false
				} : false,
				namespace: 'mediaPan'
			});

			$body.on(endEvent, function() {
				xInit = x;
				yInit = y;

				$body.off(moveEvent)
					.off(endEvent);

				disable = setTimeout(function() {
					disable = scope.panning = false;

					if (! scope.zoomed) {
						xInit = yInit = 0;
					}
				}, 100);
			}, {
				namespace: 'mediaPan'
			});
		}, {
			namespace: 'mediaPan'
		});
	},

	/**
	 * Scale media assets
	 *
	 * @param {Function} [fn]
	 */
	scaleMedia: function(fn) {
		var scope = this,
			$container = scope.$container,
			image = scope.$image[0],
			loaded = function() {
				$container.removeClass('-is-loading');

				if (fn) {
					fn();
				}

				image.removeEventListener('load', loaded);
			};

		scope.scaled = true;

		$container.addClass('-is-loading');

		image.addEventListener('load', loaded, false);

		image.src = image.src.replace(scope.options.size, 'Large');
	},

	/**
	 * Restore media assets
	 */
	restoreMedia: function() {
		var scope = this,
			image = scope.$image[0];

		scope.$container.off('.mediaPan');

		scope.scaled = false;
		scope.zoomed = false;

		scope.$container.removeClass('-is-zoomed');

		image.src = image.src.replace('Large', scope.options.size);

		image.removeAttribute('style');
		image.removeAttribute('width');
		image.removeAttribute('height');
	}
});